<template>
<div>
<CCol>
    <file-pond v-if="toShow" 
          @addfile="getImages"
          @removefile="removedImages"
          name="test"
          :ref="reference"
          :label-idle="label"
          :allow-multiple="allowMultiple"
          :allowBrowse="allowBrowse"
          :accepted-file-types="type"
          :allowImagePreview="allowImagePreview"
          :allowImageTransform="allowImageTransform"
        />
        <br />
        <br />
       <!-- {{isEditMode}} -->
        </CCol>
        <CCol >
            <div :key="toRecreate" v-if="typeImg!=null" >
              <ul>
                <gallery v-if="images && images.url"
                :id="(/\s/.test(imageIndex))?imageIndex.split(' ').join(''):imageIndex+'1'"
                  :images="images.url"
                  :index="images.index"
                  :options="{container:(/\s/.test(imageIndex))?'#'+imageIndex.split(' ').join(''):'#'+imageIndex+'1'}"
                  @close="index=null,images.index=null"
                ></gallery>
                               <div class="image" v-for="(img,imgIndex) in typeImg" :key="img.imageid+imgIndex">
                  <span v-if="isEditMode &&img.imageUrlpath" @click="deleteHotelImage(img)" id="close">&times;</span>
             
                  <img v-if="img.imageUrlpath"
                  @click="images.index=imgIndex"
                    :id="img.imageid"
                    :src="img.imageUrlpath"
                    style="display:inline; height:200px; width:300px;"
                  />
                </div>
              </ul>
            </div>
        </CCol>
        <div :show="alert" v-if='alert'
       class="err-msg" :class="alert.substring(8,21)==$t('cHotelImages.successfully')?'success':'danger'">
        {{alert}}
       <div @click="alert=null,emitAlertstatus(imageIndex)" class='align-alert' >
        <CIcon  name="cilXCircle">
        </CIcon>
       </div>
     </div> 
        </div>
</template>
<script>
import vueFilePond from "vue-filepond";
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import BaseConfiguration from "../../../../config/base";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import {
  COMPONENT_NAME,
  PATHNAME,
  DATE_TIME_FORMAT,IMAGE_TYPES,ROOM_IMAGE_TYPES,
} from "../../../../util/constants";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  groupBy,
  cloneDeep,cloneData
} from "../../../../util/util";
import VueGallery from "vue-gallery";
import Logger from "../../../../services/logger";
//   Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileEncode,
);
export default {
    name: COMPONENT_NAME.C_IMAGES,
  components: {
    FilePond,
    gallery: VueGallery,
  },
  data: () => {
    return {
      myFiles: [],
      images:null,
      imageLs:[],
      imageLength:0,
      completedLength:0,
      orgImgLs:[],
      toRecreate:1,
      alert:null,
      toShowfilePond:false
    };
  },

 watch:{
   imageUrl: function(val){
     this.images = val
   },
   editMode: function(val){
     this.toRecreate +=1 ;
     if(!val){
      //  this.imageLs = []
       this.imageLength = 0;
       this.completedLength = 0;
     }
   },
  
 },

  props: {
    alertValue: {
      type: String,
      default: null,
    },
      imageIndex: {
      type: String,
      default: null,
    },
    toShow: {
      type: Boolean,
      default: false,
    },
    allowImagePreview: {
      type: Boolean,
      default: false,
    },
    allowMultiple: {
      type: Boolean,
      default: false,
    },
    allowBrowse: {
      type: Boolean,
      default: false,
    },
    allowFileEncode: {
      type: Boolean,
      default: false,
    },
    allowImageTransform: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "image/jpeg, image/png",
    },
    label: {
      type: String,
      default: "Drop files here or <span class='filepond--label-action'>Browse</span>",
    },
    reference: {
      type: String,
      default: null,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: Object,
      default: null,
    },
    galleryShow: {
      type: Boolean,
      default: false,
    },
    typeImg: {
      type: Array|Object,
      default: null,
    },
  },

  created(){
    if(this.imageUrl){
      this.images = this.imageUrl
    }
    this.alert = this.alertValue;
    this.isEditMode = this.editMode;
    this.toShowfilePond = this.toShow;
  },
  methods:{

    emitAlertstatus(type){
      this.$emit('getAlertVal',type);
    },
    
assignEditVal(pEditMode){
  // this.toShowfilePond = pEditMode;
 this.isEditMode = pEditMode
},

assignalertVal(palert){
 this.alert = palert
},

removeImg(error,file){

},


    removedImages(error, file) {
        try {
          if(BaseConfiguration.isDebug) console.log("removedImages");
           let type = this.imageIndex;
          let order = this.typeImg;
          let removedObj;
          this.completedLength--;
          if(this.$refs[type].getFiles().length==0){
            this.$emit('getEncodedImages',file,true);
            // this.$delete(this.orgImgLs,0)
            // console.log(this.orgImgLs)
          }else{
            let tempImgLs=[];
            let imageObj=null;
          
      //        for (let index = 0; index < this.$refs[type].getFiles().length; index++) {
      //          imageObj = cloneData({
      //   image: null,
      //   type: null,
      //   isMainImage: null,
      //   sortOrder: 0,
      // })
      //       imageObj.image = this.$refs[type].getFiles()[index].getFileEncodeDataURL();
      //     imageObj.type = type;
      //     imageObj.isMainImage = (type==ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE|| type==IMAGE_TYPES.OPTIONS.MAIN_IMAGE)?true:false;
      //     tempImgLs.push(imageObj);
      //        }

          // removedObj = this.orgImgLs.filter(o1 => !tempImgLs.some(o2 => o1.image === o2.image));
            this.$emit('getEncodedImages',file,true) 
            // this.imageLs=[]
          }
        
       
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_IMAGES,
                  "error in removedImages",
                  err.toString(),
                  "removedImages",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
    }, 
     
      deleteHotelImage(img) {
          try {
            if(BaseConfiguration.isDebug) console.log("deleteHotelImage");
            this.$emit('toDeleteImg',img)
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.C_IMAGES,
                    "error in deleteHotelImage",
                    err.toString(),
                    "deleteHotelImage",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
    }, 


        getImages(error, file) {
          let type = this.imageIndex;
          let order = this.typeImg;
         if(this.imageLs.length==0){
           this.imageLength=0;
          //  this.completedLength=0;
         }
           let imageObj= {
        image: null,
        type: null,
        isMainImage: null,
        sortOrder: 0,
      }
      if ((type == ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE|| type==IMAGE_TYPES.OPTIONS.MAIN_IMAGE) ? !order[0].hasOwnProperty('imageid') : true) {
        
          this.imageLength++;
          console.log(this.imageLength)
          // for (let index = 0; index < this.$refs[type].getFiles().length; index++) {
            imageObj = cloneData({
        image: null,
        type: null,
        isMainImage: null,
        fileName:null,
        sortOrder: 0,
      })
      if(file.getFileEncodeDataURL().substring(23,29)!='null'){
            imageObj.image = file.getFileEncodeDataURL();
            imageObj.fileName = file.filenameWithoutExtension;
          imageObj.type = type;
          imageObj.isMainImage = (type==ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE|| type==IMAGE_TYPES.OPTIONS.MAIN_IMAGE)?true:false;
          this.imageLs.push(imageObj);
      } else{
        console.log('null')
      }
          // }
          // this.$emit('getEncodedImages',this.imageLs,false) 
          console.log(this.imageLength,this.completedLength,this.$refs[type].getFiles().length)
        
        if((this.imageLength+this.completedLength)==this.$refs[type].getFiles().length ){
          
          this.completedLength=this.imageLength;
          this.imageLength=0
         
        this.$emit('getEncodedImages',this.imageLs,false) 
        let lsimg=cloneDeep(this.imageLs)
        for (let img = 0; img < lsimg.length; img++) {
          this.orgImgLs.push(lsimg[img])
          
        }
        this.imageLs=[]
        }
      } else {
       this.$emit('getEncodedImages',null)
      }

    //   console.log(this.imageObj);
    },
  }
}
</script>
<style scoped>
.image {
  float: left;
  background-size: contain;
  background-repeat: no-repeat;
  border: 1px solid #ebebeb;
  background-position: 50% 50%;
  margin: 5px;
}
.err-msg.success{
  background: #048204ab;
  width:auto;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 10px;
  color: white;
  position: absolute;
  top: 1px;
  right: 2px;
  padding-left: 33px;
}
.err-msg.danger{
  background: #ce0000;
  width:auto;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 10px;
  color: white;
  position: absolute;
  top: 1px;
  right: 2px;
  padding-left: 33px;
}
</style>